import { useQuery } from "@tanstack/react-query";
import { listLoraBaseModels, listLoraKinds } from "../../services/lorasApi";
import { loraQueryKeys } from "./queryKeys";

/**
 * Static catalog read — base models change very rarely (config-table
 * entries, not user data), so we keep them in cache indefinitely.
 */
export function useLoraBaseModels() {
  return useQuery({
    queryKey: loraQueryKeys.baseModels(),
    queryFn: listLoraBaseModels,
    staleTime: Infinity,
  });
}

export function useLoraKinds() {
  return useQuery({
    queryKey: loraQueryKeys.kinds(),
    queryFn: listLoraKinds,
    staleTime: Infinity,
  });
}
